import styled from "styled-components";

export const TopDiv = styled.div`
height: 20vh;
background: black;
position: relative;

@media only screen and (max-width: 899px) and (min-width: 600px)  {
    height: 200px;
}

  @media screen and (min-width: 900px) {
    
  }

`